import {
  readFromLocalStorage,
  saveToLocalStorage,
} from "./localStorageHandler";
import { authUser } from "../../user-module/helpers/authHelper";
import store from "../../../store";

export const formatPrice = (price, currency) => {
  try {
    const decimals = ["KD", "KWD", "BHD", "OMR"].includes(currency) ? 3 : 2;
    return `${price?.toFixed(decimals)} ${currency ?? ""}`;
  } catch (e) {
    console.log("currencyHelper.formatPrice:exception:", e.message);
  }
};

export const getCountryCurrencyRate = () => {
  const country = ((authUser() || {}).address || {}).country || "US";
  const currency = getSavedCurrency() || "USD";
  const currencyTable = store.state.currencyTable;

  if (currencyTable) {
    const baseCurrency = currencyTable.baseCurrency || "USD";

    const currencyRate = (
      currencyTable.items.find(
        x =>
          x.symbol === `${baseCurrency}${currency}` ||
          x.symbol === `${baseCurrency}-${currency}` ||
          x.symbol === `${baseCurrency}/${currency}` ||
          x.symbol === currency
      ) || {}
    ).rate;

    if (currencyRate) return { country, currency, currencyRate };
  }

  return { country, currency: "USD", currencyRate: 1 };
};

export const getSavedCurrency = () => {
  return readFromLocalStorage("Currency");
};

export const saveCurrency = value => {
  saveToLocalStorage("Currency", value);
};
